import React from 'react';

import { useSnackbar } from 'notistack';

import { Button, ButtonProps } from '@mui/material';

import { useConfirmDialog } from '~/components/Common/Providers/ConfirmDialogProvider';

import { usePublishRentalOffer } from '~/hooks/apis/offers/usePublishRentalOffer';

interface Props {
  offerId: string;
  onPublished?: () => void;
  variant?: ButtonProps['variant'];
  sx?: ButtonProps['sx'];
}

export default function PublishRentalOfferButton({ offerId, onPublished, variant = 'text', sx }: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const showConfirmDialog = useConfirmDialog();
  const publishOffer = usePublishRentalOffer(offerId);

  async function handleClick() {
    const confirmed = await showConfirmDialog({
      title: 'Publish this rental offer?',
      description: 'This will switch the property, rate plan, package and offer to content approved.',
    });
    if (!confirmed) {
      return;
    }

    publishOffer.mutate(undefined, {
      onSuccess: () => {
        enqueueSnackbar('Offer published', { variant: 'success' });
        onPublished?.();
      },
      onError: (error) => {
        enqueueSnackbar(`Error publishing offer: ${error.message}`, { variant: 'error' });
      },
    });
  }

  return (
    <Button size="small" variant={variant} disabled={publishOffer.isPending} onClick={handleClick} sx={sx}>
      Publish
    </Button>
  );
}
